import { useEffect, useState } from 'react';
import { Typography } from '../typography';
import { Button } from '../button';
import { InputPrice } from '../input';
import { enqueueSnackbar } from '../snackbar';
import { ModalBase, ModalWrapper, ModalFooterButtons } from './ModalComponents';
import { useOfferUpdateMutation } from '../../hooks';
import { MESSAGES } from '../../const';
import { i18n } from '../../i18n';

export const offerUpdateModal: any = {};

export const OfferUpdateModal = () => {
  const { mutate } = useOfferUpdateMutation();
  const [open, setOpen] = useState(false);
  const [price, setPrice] = useState(0);

  useEffect(() => {
    offerUpdateModal.open = () => {
      offerUpdateModal.action = 'Update Offer';
      offerUpdateModal.name = `${offerUpdateModal.action} ${offerUpdateModal.number} - $${offerUpdateModal.price}`;

      offerUpdateModal.isSubmitClicked = false;
      setPrice(offerUpdateModal.price);
      setOpen(true);
    };
  }, []);

  const handleOnClose = () => {
    Object.keys(offerUpdateModal).forEach((key) => {
      if (key !== 'open') delete offerUpdateModal[key];
    });
    setOpen(!open);
  };

  const handleSubmitClick = async () => {
    mutate(
      { id: offerUpdateModal.id, price },
      {
        onSuccess: () => {
          setOpen(false);
          offerUpdateModal.submitClick();
        },
        onError: () => {
          enqueueSnackbar(MESSAGES.OFFER.ERROR.NOT_UPDATED, 'error');
        },
      },
    );
  };

  return (
    <ModalBase id={'offer-update-modal'} open={open} onClose={handleOnClose}>
      <ModalWrapper>
        <Typography variant={'textL'} weight={'bold'}>
          {offerUpdateModal.name}
        </Typography>
        <InputPrice
          label={i18n.t('label.price')}
          data-size={'medium'}
          defaultValue={price}
          onChange={(e) => setPrice(Number(e.target.value))}
        />
        <ModalFooterButtons>
          <Button size={'medium'} data-color={'white'} onClick={handleOnClose}>
            {i18n.t('button.cancel')}
          </Button>
          <Button size={'medium'} data-color={'primary'} onClick={handleSubmitClick}>
            Update Offer
          </Button>
        </ModalFooterButtons>
      </ModalWrapper>
    </ModalBase>
  );
};
